import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
  Grid,
} from "@mui/material";

export default function FilterPanel({
  company,
  setCompany,
  fromSequence,
  setFromSequence,
  toSequence,
  setToSequence,
  companyOptions = [],
}) {
  return (
    <Box
      sx={{
        mb: 3,
        backgroundColor: "#f8fafc",
        p: { xs: 2, sm: 3 },
        borderRadius: "16px",
        maxWidth: 900,
        mx: "auto",
        boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
      }}
    >
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <FormControl fullWidth size="small">
            <Autocomplete
              options={companyOptions}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) => option.value === value}
              value={companyOptions.find((o) => o.value === company) || null}
              onChange={(_, newValue) =>
                setCompany(newValue ? newValue.value : "")
              }
              renderInput={(params) => (
                <TextField {...params} label="Company Name" size="small" />
              )}
            />
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="From Sequence Number"
            type="number"
            value={fromSequence}
            onChange={(e) => setFromSequence(e.target.value)}
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="To Sequence Number"
            type="number"
            value={toSequence}
            onChange={(e) => setToSequence(e.target.value)}
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid> */}
      </Grid>
    </Box>
  );
}
